module.exports = __webpack_public_path__ + "static/index/img/member_home_ico.ebfc3821.png";